import React from "react";
import { ArrowPathIcon } from "@heroicons/react/24/outline";

const DeletedList = ({ deletedQuestions, restoreQuestion }) => {
  return (
    <section className="rounded-lg border border-slate-200 bg-white p-5 shadow-sm">
      <div className="mb-5">
        <h3 className="text-lg font-bold text-slate-950">Deleted Questions</h3>
        <p className="text-sm text-slate-500">Recently removed questions can be restored to the active table.</p>
      </div>

      {deletedQuestions.length === 0 ? (
        <div className="rounded-lg border border-slate-100 bg-slate-50 px-4 py-10 text-center text-sm text-slate-500">
          No deleted questions available.
        </div>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full min-w-[760px] text-left text-sm">
            <thead>
              <tr className="border-y border-slate-100 bg-slate-50 text-xs uppercase tracking-wide text-slate-500">
                <th className="px-4 py-3 font-semibold">ID</th>
                <th className="px-4 py-3 font-semibold">Q Title</th>
                <th className="px-4 py-3 font-semibold">Title</th>
                <th className="px-4 py-3 font-semibold">Deleted At</th>
                <th className="px-4 py-3 font-semibold">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {deletedQuestions.map((question) => (
                <tr key={question.id} className="text-slate-700 transition hover:bg-slate-50">
                  <td className="px-4 py-4 text-slate-500">{question.id}</td>
                  <td className="px-4 py-4 font-semibold text-slate-950">{question.q_title}</td>
                  <td className="px-4 py-4">{question.title}</td>
                  <td className="px-4 py-4">{new Date(question.deletedAt).toLocaleString()}</td>
                  <td className="px-4 py-4">
                    <button
                      onClick={() => restoreQuestion(question.id)}
                      className="inline-flex h-9 items-center gap-2 rounded-lg bg-sky-600 px-3 text-sm font-semibold text-white transition hover:bg-sky-700"
                    >
                      <ArrowPathIcon className="h-4 w-4" />
                      Restore
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
};

export default DeletedList;
